import { render, staticRenderFns } from "./TbFilaDetail.vue?vue&type=template&id=723a4e2e&scoped=true"
import script from "./TbFilaDetail.vue?vue&type=script&lang=js"
export * from "./TbFilaDetail.vue?vue&type=script&lang=js"
import style0 from "./TbFilaDetail.vue?vue&type=style&index=0&id=723a4e2e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "723a4e2e",
  null
  
)

export default component.exports